import { FormikProps } from 'formik'
import { useEffect, useRef } from 'react'
import { useDispatch } from 'react-redux'
import { MODAL_TYPES } from '../../../common/constants'
import { showModal } from '../../../store/modal'
import { FormInputConfig } from '../../../utils/formUtils/types'
import { resolveValidationErrorLabels } from './utils'

/**
 * Hook to trigger FormValidationErrorModal when validation errors are detected.
 *
 * @param {Object} formik - Formik instance (needs isValid, submitCount, errors)
 * @param {Array} inputs - Array of input configurations (form field definitions)
 */
export function useFormValidationErrorModal(formik: FormikProps<any>, inputs: (FormInputConfig | null | undefined | false)[]) {
    const dispatch = useDispatch()

    // Refs keep track of latest values without causing effect re-triggers
    const inputsRef = useRef(inputs)
    const errorsRef = useRef(formik.errors)
    inputsRef.current = inputs
    errorsRef.current = formik.errors

    useEffect(() => {
        if (!formik.isValid && formik.submitCount > 0) {
            const validInputs = inputsRef.current.filter((input): input is FormInputConfig => Boolean(input))
            const errorLabels = resolveValidationErrorLabels(errorsRef.current, validInputs)

            if (!errorLabels.length) return

            const payload = {
                modalType: MODAL_TYPES.FORM_VALIDATION_ERROR_MODAL,
                modalProps: { errorLabels },
            }

            dispatch(showModal(payload))
        }
    }, [formik.submitCount, formik.isValid, dispatch])
}
